import Link from "next/link";

const WhatsTheDifference = () => (
  <div>
    While your bank hypothecates your funds for a number of risky propositions,
    Data Mynt facilitates ‘staking’ of funds.
    <br />
    <br />
    Some blockchain protocols allow participants to earn additional
    cryptocurrency by contributing to the network. These rewards can be earned
    in many different ways including staking, inflation, savings rates, etc.
    Data Mynt wants businesses to be able to benefit from these protocols. Data
    Mynt will facilitate participation in these networks and pass on the rewards
    to eligible businesses who have opted into this feature.
    <br />
    <br />
    Data Mynt supports the growth of modern, global businesses with global
    financial solutions.
    <br />
    <br />
    <ul>
      <li>No monthly fees</li>
      <li>No minimum balance required</li>
      <li>Immediate settlement, payments and liquidity management</li>
      <li>Control over your payroll</li>
    </ul>
    Meanwhile, business savings accounts offered by legacy banks:
    <br />
    <br />
    <ul>
      <li>Up to 10 business days for international wire transfers</li>
      <li>$16 average fee to receive international wire transfers*</li>
      <li>$49 average fee to send international wire transfers*</li>
      <li>APY ranging from 0.10% to 0.60%**</li>
    </ul>
    <br />
    <Link href="https://www.mybanktracker.com/news/wire-transfer-fee-comparison-top-10-us-banks">
      <a className="text-primary" target="_blank" rel="noreferrer">
        *Source
      </a>
    </Link>
    <br />
    <Link href="https://www.fastcapital360.com/blog/best-high-yield-business-savings-accounts/">
      <a className="text-primary" target="_blank" rel="noreferrer">
        **Source
      </a>
    </Link>
  </div>
);

export default WhatsTheDifference;
